import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/catch';
import {Injectable} from '@angular/core';
import {ApiEndpoints} from '../ApiEndpoints';
import {ApiUtils} from '../ApiUtils';
import 'rxjs/add/operator/map';
import { plainToClass } from 'class-transformer';
import { SharedMethods } from '../../../../util/sharedMethods-service';
import { Article } from '../../model/article';


@Injectable()
export class ArticleService {

  articles: Article[];

  iSconnecting: boolean = false;

  constructor(public apiEndpoints: ApiEndpoints, public http: HttpClient,
              public apiUtils: ApiUtils,
              // public networkService:NetworkService,
              // public sharedMethods: SharedMethods
              public sharedMethods: SharedMethods,
  ) { }


  deleteArticleProvider(id){

    return this.http.delete(this.apiEndpoints.GET_URL_DELETE_ARTICLE(id), {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});

  }

  getArticleProvider(){
   return this.http.get<Article[]>(this.apiEndpoints.URL_GET_ARTICLE, {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});
  }

  getOneArticleProvider(id){
   return this.http.get(this.apiEndpoints.URL_GET_ARTICLEBYID(id), {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});
  }

  addArticleProvider(art: Article){

      let id_cat: number[];
      id_cat = [];

      if ( art.categories !== undefined && art.categories !== null) {
        for ( let i = 0; i < art.categories.length; i++) {
          id_cat.push(art.categories[i].id);
        }
      }

      const body=  {
        titre: art.titre,
        description: art.description,
        slug: art.slug,
        isPublish: art.is_publish,
        datePublish: art.date_publish,
        photoSelected: art.photo,
        categories: id_cat,
                
      };
    
     var donnees = JSON.stringify(body);
     console.log(donnees);
     return this.http.post(this.apiEndpoints.GET_URL_POST_ARTICLE, donnees, {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});
   
   }




   updateArticleProvider(art: Article){

  

    let id_cat: number[];
    id_cat = [];

    if ( art.categories !== undefined && art.categories !== null) {
      for ( let i = 0; i < art.categories.length; i++) {
        id_cat.push(art.categories[i].id);
      }
    }


    const body=  {
      titre: art.titre,
      description: art.description,
      slug: art.slug,
      isPublish: art.is_publish,
      datePublish: art.date_publish,
      photoSelected: art.photo,
      categories: id_cat,
               
     };

    
     var donnees = JSON.stringify(body);
     
     return this.http.patch(this.apiEndpoints.GET_URL_PUT_ARTICLE(art.id), donnees, {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});
   }




}
